module.exports = __webpack_public_path__ + "static/img/title-logo.8adfcaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title-logo.png
// module id = 15
// module chunks = 0